import { render, staticRenderFns } from "./DeliveryDelay.vue?vue&type=template&id=e85e92a0"
import script from "./DeliveryDelay.vue?vue&type=script&lang=ts"
export * from "./DeliveryDelay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports